<template>
    <vx-card title="Notifications List">
      <transition name="fade-del-btn">
        <div v-if="hasSelected">
          <a-button color="primary" type="primary" @click="deleteSelected()">
            Delete Selected
          </a-button>
          <span class="ml-4">
            Selected {{ selectedRows.length }} {{ selectedRows.length === 1 ? 'item' : 'items' }}
          </span>
        </div>
      </transition>

<!--      :options="{ placeholder:'Search',noContent: 'No data',is_row_selection: false,is_load_req: false }"-->
        <XTable
          ref="tbl"
          :search="false"
          :options="{ placeholder: 'Search', noContent: 'No data', is_row_selection: true }"
          hasWrited
          :model="model"
          class="mt-5"
          @selectedRows="selectedRowsChanged"
        >
          <span slot="date" slot-scope="text,record">
            {{ setDateFormat(text.record.created_at.$date) }}
          </span>
          <span slot="title" slot-scope="text,record">
            <span
              v-if="text.record"
              :class="!text.record.is_read ? 'font-semibold' : ''"
            >
              {{ text.record.title }}
            </span>
          </span>
          <span slot="read" slot-scope="text,record">
            <feather-icon v-if="text.record.is_read" icon="CheckIcon" svg-classes="text-success w-5 h-5"></feather-icon>
            <feather-icon v-else icon="XIcon" svg-classes="text-danger w-5 h-5"></feather-icon>
          </span>
          <span slot="description" slot-scope="text,record">
            <span class="flex items-center gap-2">
              <a-popover placement="bottom">
                <template slot="content">
                  {{ text.record.description }}
                </template>
                <feather-icon
                  icon="EyeIcon"
                  svg-classes="text-warning w-5 h-5"
                  class="border border-solid border-gray-500 border-warning p-1 rounded"
                >
                </feather-icon>
              </a-popover>
              <span>{{ limitTextTask(text.record.description) }}</span>
            </span>
          </span>
        </XTable>
    </vx-card>
</template>

<script>
import * as TableColSnippet from "./textSnippetsTbl";
import XTable from "../../../../components/x-table/XTable";
import axios from "@/axios";
import moment from 'moment'
import mixin from '@/views/mixin/mixin'

export default {
  name: "TextSnippets",
  mixins: [mixin],
  components:{
    XTable
  },
  data(){
    return{
      model: null,
      notifications: [],
      selectedRows: [],
    }
  },
  computed: {
    hasSelected(){
      return this.selectedRows.length > 0
    },
  },
  methods: {
    async getListNtf(){
      await this.$refs.tbl.fetch()
      // try{
      //   // this.$refs.tbl.loading = true
      //   // const { data } = await axios.post('/dashboard/notification/',{ page: 1, limit: 10 })
      //   // this.$refs.tbl.data = data
      // }catch (e) {
      //   this.$message.error('Server error')
      //   throw new Error(e)
      // }finally {
      //   // this.$refs.tbl.loading = false
      // }
    },
    selectedRowsChanged(e) {
      this.selectedRows = e
    },
    async deleteSelected() {
      if (this.selectedRows.length === 0) this.$message.error('Select one or more notifications to delete them.')
      const selectedIds = this.selectedRows.map(item => item._id.$oid)

      try {
        this.$refs.tbl.loading = true
        const { data } = await axios.delete('/dashboard/notification/', { data: { id: selectedIds } })
        this.$refs.tbl.clearSelection()
        await this.$refs.tbl.fetch()
      } catch (e) {
        this.$message.error('Server error')
      } finally {
        this.$refs.tbl.loading = false
      }
    },
  },
  async mounted() {
    await this.getListNtf()
  },
  created() {
    this.model = TableColSnippet.default
  }
}
</script>

<style scoped>
  .fade-del-btn-enter-active, .fade-del-btn-leave-active {
    transition: opacity .3s
  }
  .fade-del-btn-enter, .fade-del-btn-leave-active {
    opacity: 0
  }
</style>
